module.exports = __webpack_public_path__ + "img/sld_scb_2_t1_green.3bcc73e2.svg";